/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Health_Nav_Landing_Feature_2Inputs */

const en_service_health_nav_landing_feature_2 = /** @type {(inputs: Service_Health_Nav_Landing_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wellness resources`)
};

const fr_service_health_nav_landing_feature_2 = /** @type {(inputs: Service_Health_Nav_Landing_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressources de bien-être`)
};

/**
* | output |
* | --- |
* | "Wellness resources" |
*
* @param {Service_Health_Nav_Landing_Feature_2Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_health_nav_landing_feature_2 = /** @type {((inputs?: Service_Health_Nav_Landing_Feature_2Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Health_Nav_Landing_Feature_2Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_health_nav_landing_feature_2(inputs)
	return fr_service_health_nav_landing_feature_2(inputs)
});